import { useState } from 'react';

export const useTasksScreen = () => {
  const [selectedKey, setSelectedKey] = useState('roboCall');
  // const [showRoboCall, setshowRoboCall] = useState(true);
  // const [showMedVox, setshowMedVox] = useState(false);

  // const updateData = (key: string) => {
  //   switch (key) {
  //     case 'roboCall':
  //       setSelectedKey('roboCall');
  //       setshowRoboCall(true);
  //       setshowMedVox(false);
  //       break;
  //     case 'medVox':
  //       setSelectedKey('medVox');
  //       setshowMedVox(true);
  //       setshowRoboCall(false);
  //       break;
  //   }
  // };

  const updateData = (key: string) => {
    switch (key) {
      case 'roboCall':
        setSelectedKey('roboCall');
        break;
      case 'medVox':
        setSelectedKey('medVox');
        break;
    }
  };

  return {
    selectedKey,
    updateData,
    // showRoboCall,
    // showMedVox,
  };
};
